import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Blog ID", -1)
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "required" }
const _hoisted_15 = { class: "col-lg-8 fv-row" }
const _hoisted_16 = ["label"]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_22 = { class: "col-lg-8 fv-row" }
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "row mb-6" }
const _hoisted_26 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_27 = { class: "col-lg-8 fv-row" }
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_32 = { class: "col-lg-8" }
const _hoisted_33 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true"
}
const _hoisted_34 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change image"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle-fill fs-6" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_create"
}, null, -1)
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "form-text" }
const _hoisted_40 = { class: "row mb-6" }
const _hoisted_41 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_42 = { class: "col-lg-8 fv-row" }
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "row mb-6" }
const _hoisted_46 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_47 = { class: "col-lg-8 fv-row" }
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "row mb-6" }
const _hoisted_51 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_52 = { class: "col-lg-8 fv-row" }
const _hoisted_53 = { class: "row mb-6" }
const _hoisted_54 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_55 = { class: "col-lg-8 fv-row" }
const _hoisted_56 = { class: "row mb-6" }
const _hoisted_57 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_58 = { class: "col-lg-8 fv-row" }
const _hoisted_59 = { class: "fv-plugins-message-container" }
const _hoisted_60 = { class: "fv-help-block" }
const _hoisted_61 = { class: "row mb-6" }
const _hoisted_62 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_63 = { class: "col-lg-8 fv-row" }
const _hoisted_64 = { class: "fv-plugins-message-container" }
const _hoisted_65 = { class: "fv-help-block" }
const _hoisted_66 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_67 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_68 = { class: "indicator-label" }
const _hoisted_69 = { class: "indicator-progress" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('update', 'indices'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('editTestimonial')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate,
            "validation-schema": _ctx.validationSchema,
            "initial-values": _ctx.testimonial
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "blogId",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: "0"
                    }),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "blogId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.translate('typeOfIndex')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "type",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedType,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedType) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          disabled: "",
                          selected: "",
                          label: _ctx.translate('selectTypeOfIndex')
                        }, null, 8, _hoisted_16),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.IndicesType, (type) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: type.id,
                            value: type.id
                          }, _toDisplayString(type.nameAr), 9, _hoisted_17))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_ErrorMessage, { name: "type" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.translate('englishName')), 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "nameEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('englishName')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_ErrorMessage, { name: "nameEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.translate('arabicName')), 1),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "nameAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('arabicName')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_ErrorMessage, { name: "nameAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.translate('avatar')), 1),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", {
                        class: "image-input-wrapper w-125px h-125px",
                        style: _normalizeStyle(`background-image: url(${_ctx.thumbnail})`)
                      }, null, 4),
                      _createElementVNode("label", _hoisted_34, [
                        _hoisted_35,
                        _createVNode(_component_Field, {
                          type: "file",
                          name: "avatar",
                          accept: ".png, .jpg, .jpeg",
                          onChange: _ctx.previewImage
                        }, null, 8, ["onChange"]),
                        _hoisted_36
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_ErrorMessage, { name: "avatar" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.translate('allowedFileTypes')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.translate('contentEnglish')), 1),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_Field, {
                      as: "textarea",
                      name: "contentEn",
                      rows: "4",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('contentEnglish')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_ErrorMessage, { name: "contentEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.translate('contentArabic')), 1),
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_Field, {
                      as: "textarea",
                      name: "contentAr",
                      rows: "4",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('contentArabic')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_ErrorMessage, { name: "contentAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.translate('likesCount')), 1),
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "likesCount",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: "0"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.translate('okayCount')), 1),
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "okayCount",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: "0"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.translate('publishDate')), 1),
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_Field, {
                      type: "datetime-local",
                      name: "publishDate",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid"
                    }),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_component_ErrorMessage, { name: "publishDate" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.translate('referenceLink')), 1),
                  _createElementVNode("div", _hoisted_63, [
                    _createVNode(_component_Field, {
                      type: "url",
                      name: "referenceLink",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('referenceLink')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_ErrorMessage, { name: "referenceLink" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_67, [
                  _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_69, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_70
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema", "initial-values"])
        ])
      ]))
    : _createCommentVNode("", true)
}